import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/researchgate': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32h448v448h-448v-448zM262.2 366.4v-7.3c-10 0-20-6.9-27.2-14.7-12.2-13.3-28.6-34.7-42.2-58.9 22.5-5.3 39.2-26.4 39.2-47.5 0-31.2-24.2-45.6-55.9-45.6-17.8 0-45.1 1.6-70.9 0.6v8.1c15.6 2.9 22 1.3 22 23.9v109.4c0 22.6-6.5 21-22 23.9v8.1c7.5-0.2 20.5-0.8 33.6-0.8 12.5 0 28.7 0.5 35.6 0.8v-8.1c-19.8-2.7-25.8-0.4-25.8-23.9v-46.4c6.7 0.6 12.5 0.6 21.4 0.6 16.9 30.3 33 53 42.2 63.6 16.8 20.2 43.4 17.2 50 14.2zM285.1 231.4c38.7 0 34-29.4 34-49.9h-30.4v10.7h17.9c0 15.9-7.4 26.8-21.5 26.8-11.3 0-17.9-9.9-17.9-23.3v-26.8c0-12.4 11.8-19.7 19.7-19.7 14.2 0 19.7 12.5 19.7 12.5l10.7-7.2s-5.2-17.9-30.4-17.9c-25.2 0-34 18.2-34 30.4v32.2c0 16.5 8.9 32.2 32.2 32.2zM168.6 276.1c-9.4 0-13.6-0.3-20-0.8v-69.7c6.4-0.6 15-0.6 22.5-0.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/researchgate.js
// module id = 994
// module chunks = 0